<template>
  <div class="express-picker">
    <mt-popup
      v-model="isShow"
      position="bottom"
      popup-transition="popup-fade"
      style="width: 100%;"
      :closeOnClickModal="false"
      v-clickoutside="closePopup"
    >
      <div class="m-picker-toolbar">
        <button class="m-picker-btn" @click="closePopup">关闭</button>
        <button class="m-picker-btn" @click="onSubmit">确定</button>
      </div>
      <mt-picker :slots="data" valueKey="express_name" @change="onValuesChange" showToolbar></mt-picker>
    </mt-popup>
  </div>
</template>

<script>
export default {
  name: "ExpressPicker",
  data() {
    return {
      express: {}
    };
  },
  props: {
    expresses:Array,
    isShow: {
      type: Boolean,
      default: false
    },
    code: []
  },
  computed: {
    data() {
      return [{
        flex: 1,
        values: this.expresses
      }];
    }
  },
  methods: {
    // 获取快递公司
    // getExpresses() {
    //   this.$.http.post('basic/expresses',{}).then(res=>{
    //     this.expresses = res.data
    //     console.info(this.expresses)
    //   })
    // },
    closePopup() {
      this.$emit("update:isShow", false);
    },
    onSubmit() {
      this.$emit('select', this.express);
      this.closePopup();
    },
    onValuesChange(picker, values) {
      this.express = values[0];
    }
  },
  mounted() {

    // this.getExpresses()
  },
  watch:{
    isShow(value){
      if(value){
        console.info(this.expresses)
      }
    }
  }

};
</script>

<style>
.picker-item {
  text-align: center;
}
.m-picker-toolbar {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eaeaea;
}
.m-picker-btn {
  color: #26a2ff;
  display: inline-block;
  width: 50%;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  color: #26a2ff;
}
.express-picker .mint-popup.mint-popup-bottom{
  padding: 0 !important
}
</style>



// WEBPACK FOOTER //
// src/pages/mobile/components/ExpressPicker/index.vue